import { IconButton, Tooltip, Menu, MenuItem, Box } from '@mui/material';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';
import FormatAlignCenterIcon from '@mui/icons-material/FormatAlignCenter';
import FormatAlignRightIcon from '@mui/icons-material/FormatAlignRight';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';

const RichTextEditorImageControls = ({
  selectedImage,
  imageMenuAnchor,
  setImageMenuAnchor,
  handleImageAlign,
  handleImageSize,
}) => {
  if (!selectedImage) return null;

  const sizeOptions = [
    { label: '25%', width: 'w-4' },
    { label: '50%', width: 'w-6' },
    { label: '75%', width: 'w-8' },
    { label: '100%', width: 'w-10' },
  ];

  return (
    <>
      <Tooltip title="Align Image">
        <IconButton
          size="small"
          className={`hover:bg-green-sage hover:text-white rounded-md ${
            selectedImage ? 'bg-green-sage text-white' : ''
          }`}
          onClick={(e) => setImageMenuAnchor({ type: 'align', element: e.currentTarget })}
        >
          <FormatAlignLeftIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="Image Size">
        <IconButton
          size="small"
          className={`hover:bg-green-sage hover:text-white rounded-md ${
            selectedImage ? 'bg-green-sage text-white' : ''
          }`}
          onClick={(e) => setImageMenuAnchor({ type: 'size', element: e.currentTarget })}
        >
          <AspectRatioIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={imageMenuAnchor?.element}
        open={Boolean(imageMenuAnchor) && imageMenuAnchor?.type === 'align'}
        onClose={() => setImageMenuAnchor(null)}
      >
        <MenuItem onClick={() => handleImageAlign('left')}>
          <FormatAlignLeftIcon fontSize="small" className="mr-2" />
          Left
        </MenuItem>
        <MenuItem onClick={() => handleImageAlign('center')}>
          <FormatAlignCenterIcon fontSize="small" className="mr-2" />
          Center
        </MenuItem>
        <MenuItem onClick={() => handleImageAlign('right')}>
          <FormatAlignRightIcon fontSize="small" className="mr-2" />
          Right
        </MenuItem>
      </Menu>
      <Menu
        anchorEl={imageMenuAnchor?.element}
        open={Boolean(imageMenuAnchor) && imageMenuAnchor?.type === 'size'}
        onClose={() => setImageMenuAnchor(null)}
      >
        {sizeOptions.map((option) => (
          <MenuItem key={option.label} onClick={() => handleImageSize(option.label)}>
            <Box className="flex items-center">
              <Box className={`${option.width} h-4 border border-gray-300 mr-2`} />
              {option.label}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default RichTextEditorImageControls;
